/* ===========================================================================
   VD · Ayudas propias sobre el formulario COD de Releasit
   ---------------------------------------------------------------------------
   Este archivo hace DOS cosas, las dos sobre el mismo formulario y con la misma
   maquinaria (por eso van juntas y no en dos archivos: una peticion menos):

   1. AUTORRELLENO de Estado y Municipio a partir del codigo postal (lo de abajo).
   2. ECO DEL TELEFONO: repite debajo del campo el numero ya formateado para que
      la persona vea su propio telefono y note el dedazo antes de enviar.
      OJO: NO comprueba que el numero tenga WhatsApp, y no se puede. La API
      oficial de Meta no tiene endpoint para consultarlo, los servicios que dicen
      hacerlo manejan sesiones no oficiales (se arriesga el baneo del numero) y
      en Mexico no se distingue celular de fijo desde la unificacion de 2019:
      libphonenumber devuelve FIXED_LINE_OR_MOBILE en los 233 pedidos medidos.

   QUE HACE (el autorrelleno)
   En Mexico el codigo postal determina el estado y el municipio. Este modulo
   escucha el campo "Codigo postal" del formulario contra entrega de Releasit y,
   en cuanto hay 5 digitos, rellena solos los desplegables de Estado y Municipio
   con los nombres EXACTOS del catalogo de cobertura. Si el codigo no esta en
   catalogo, lo avisa ahi mismo en vez de dejar que el pedido muera despues en
   Dropi.

   POR QUE
   Medido sobre 198 pedidos: entre quienes ABANDONAN, el 39,9% escribio un CP
   fuera de catalogo; entre quienes COMPRAN, el 14,6%. Y de los pedidos con CP
   fuera de catalogo, el 61,5% no llega a Dropi (contra el 4,8% del resto).

   COMO, y por que asi y no de otra forma
   El formulario es React 18 con campos CONTROLADOS: el pedido se arma del
   estado de React, no del DOM. Hay un atajo (window._rsiV2.setState) y esta
   PROHIBIDO usarlo para escribir: probado en vivo, deja el estado incoherente
   (province=JALISCO con city=MONTERREY y el desplegable vacio). La unica via
   valida es asignar el valor al <select> y disparar 'change', porque entonces
   corre el handler de Releasit, que limpia los campos dependientes.

   UN COMPORTAMIENTO DE RELEASIT QUE HAY QUE COMPENSAR
   Su <select> de Estado lleva onBlur ademas de onChange, y los dos apuntan al
   mismo handler. Resultado: con solo TOCAR el desplegable de Estado y salir, sin
   cambiar nada, se reejecuta la cascada y el Municipio se vacia. Medido. Por eso
   hay un reconciliador que vuelve a poner el municipio cuando lo borran sin que
   la persona lo haya pedido.

   REGLAS QUE SE RESPETAN
   - Cero estilos del tema sobre el formulario: no se tocan clases .rsi-. El
     unico elemento propio es el aviso del CP, con su clase y estilo en linea.
   - Nunca bloquea el envio. Si algo falla, se calla y el formulario queda como
     estaba: manual, exactamente como hoy.
   - Nunca escribe a medias: o resuelve los dos campos, o no toca ninguno.
   =========================================================================== */
(function () {
  'use strict';

  var ESPERA_RENDER_MS = 60;      /* entre escribir Estado y escribir Municipio */
  var TOPE_ESPERA_MS = 2000;      /* cuanto esperamos a que Municipio se pueble */
  var RETARDO_TECLEO_MS = 120;    /* antirrebote del tecleo */
  var VIGILANCIA_MS = 400;        /* cada cuanto revisa el reconciliador */
  var MARCA = 'vd-cp-aviso';
  var SEL_ESTADO = 'select[name="province_country_field"]';

  /* --- 1. El indice CP -> [{estado, municipio}] ---------------------------- */

  var indice = null;

  function catalogo() {
    try {
      if (window._CUSTOM_COD_FORM_PROVINCES && window._CUSTOM_COD_FORM_PROVINCES.data) {
        return window._CUSTOM_COD_FORM_PROVINCES.data;
      }
      if (window._rsiV2 && typeof window._rsiV2.getState === 'function') {
        var s = window._rsiV2.getState();
        if (s && s.coverage && s.coverage.data) return s.coverage.data;
        if (s && s.coverage) return s.coverage;
      }
    } catch (e) { /* sin catalogo no hay autorrelleno, y ya esta */ }
    return null;
  }

  function construirIndice() {
    var data = catalogo();
    if (!data) return null;
    var mapa = Object.create(null);
    for (var estado in data) {
      if (!Object.prototype.hasOwnProperty.call(data, estado)) continue;
      var muns = data[estado];
      for (var mun in muns) {
        if (!Object.prototype.hasOwnProperty.call(muns, mun)) continue;
        var cps = muns[mun];
        for (var cp in cps) {
          if (!Object.prototype.hasOwnProperty.call(cps, cp)) continue;
          /* los CP de la CDMX empiezan por cero y el catalogo puede traerlos
             como numero (1030), asi que se normalizan a 5 digitos */
          var clave = String(cp);
          while (clave.length < 5) clave = '0' + clave;
          /* sin comprobar duplicados a proposito: el recorrido visita cada par
             estado+municipio una sola vez, asi que no puede haber repetidos */
          if (mapa[clave]) mapa[clave].push({ estado: estado, municipio: mun });
          else mapa[clave] = [{ estado: estado, municipio: mun }];
        }
      }
    }
    return mapa;
  }

  function buscar(cp) {
    if (indice === null) indice = construirIndice();
    if (!indice) return null;
    var r = indice[cp];
    if (!r || !r.length) return { encontrado: false };
    /* 91 de 65.809 codigos apuntan a mas de un municipio (0,14%). En esos
       rellenamos el estado y dejamos que la persona elija el municipio, que
       para entonces ya esta filtrado a los de ese estado. */
    var estados = [];
    for (var i = 0; i < r.length; i++) if (estados.indexOf(r[i].estado) < 0) estados.push(r[i].estado);
    return {
      encontrado: true,
      ambiguo: r.length > 1,
      estadoUnico: estados.length === 1,
      estado: r[0].estado,
      municipio: r.length === 1 ? r[0].municipio : null,
      opciones: r
    };
  }

  function calentarIndice() {
    if (indice !== null) return;
    var hacerlo = function () { try { if (indice === null) indice = construirIndice(); } catch (e) { indice = false; } };
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(hacerlo, { timeout: 1500 });
    else setTimeout(hacerlo, 300);
  }

  /* --- 2. Escribir en los campos de Releasit ------------------------------- */

  /* Se levanta mientras escribimos nosotros, para poder distinguir nuestros
     propios eventos de los que genera la persona al usar el desplegable. */
  var escribiendoNosotros = false;

  function ponerSelect(el, valor) {
    if (!el) return false;
    var existe = false;
    for (var i = 0; i < el.options.length; i++) if (el.options[i].value === valor) { existe = true; break; }
    if (!existe) return false;
    escribiendoNosotros = true;
    try {
      el.value = valor;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      escribiendoNosotros = false;
    }
    return true;
  }

  function esperarSelect(nombre, ms) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function mirar() {
        var el = document.querySelector('select[name="' + nombre + '"]');
        if (el && el.options && el.options.length > 1) return resolve(el);
        if (Date.now() - t0 > ms) return resolve(null);
        setTimeout(mirar, 40);
      })();
    });
  }

  /* --- 3. El aviso del codigo postal --------------------------------------- */

  /* El input vive dentro de .rsi-text-input-row, que es una FILA flex: meter el
     aviso ahi lo convierte en columna y aplasta el campo. El sitio correcto es
     el contenedor de arriba, .rsi-text-input-wrapper, que es columna y ya
     contiene la etiqueta y la fila del error. */
  function contenedorDelCampo(campo) {
    var e = campo;
    for (var i = 0; i < 4 && e; i++) {
      e = e.parentElement;
      if (!e) break;
      var c = (e.className || '').toString();
      if (c.indexOf('input-wrapper') >= 0) return e;
    }
    return campo.parentElement ? campo.parentElement.parentElement : null;
  }

  var BASE_NOTA = 'width:100%;flex:0 0 100%;box-sizing:border-box;margin:4px 0 0;font-size:13px;line-height:1.35;';

  /* Pone (o quita) una linea de texto propia debajo de un campo. Devuelve el
     elemento para poder anadirle partes en negrita sin usar innerHTML. */
  function notaBajo(campo, clase, css) {
    var caja = contenedorDelCampo(campo);
    if (!caja) return null;
    var n = caja.querySelector(':scope > .' + clase);
    if (!n) {
      n = document.createElement('div');
      n.className = clase;
      n.setAttribute('role', 'status');
      n.style.cssText = BASE_NOTA + css;
      caja.appendChild(n);
    }
    return n;
  }
  function quitarNota(campo, clase) {
    var caja = contenedorDelCampo(campo);
    var n = caja && caja.querySelector(':scope > .' + clase);
    if (n) n.remove();
  }

  function aviso(campo, texto) {
    if (!texto) return quitarNota(campo, MARCA);
    var n = notaBajo(campo, MARCA, 'color:#e5484d');
    if (n) n.textContent = texto;
  }

  /* --- 4. El pegamento ----------------------------------------------------- */

  function tipoDelCampoCP() {
    /* el id del campo cambia por tienda: se deduce de los ajustes de la app */
    try {
      var s = window._RSI_COD_FORM_SETTINGS;
      var arr = s && s.form && s.form.items_array;
      if (!arr) return null;
      for (var i = 0; i < arr.length; i++) {
        var it = arr[i];
        if (!it || it.a === false || it.isActive === false) continue;
        var et = (it.n && (it.n.ph || it.n.label)) || it.label || '';
        if (/c[oó]digo\s*postal/i.test(et)) return it.t || it.type;
      }
    } catch (e) { /* se cae al plan B */ }
    return null;
  }

  function campoCP() {
    var t = tipoDelCampoCP();
    if (t) {
      var porNombre = document.querySelector('input[name="' + t + '"]');
      if (porNombre) return porNombre;
    }
    /* plan B: por el texto del marcador de posicion */
    var inputs = document.querySelectorAll('input[type="text"],input[type="tel"],input[inputmode]');
    for (var i = 0; i < inputs.length; i++) {
      var ph = inputs[i].getAttribute('placeholder') || '';
      if (/c[oó]digo\s*postal/i.test(ph)) return inputs[i];
    }
    return null;
  }

  var ponerValorInput = (function () {
    /* React usa un value-tracker propio: una asignacion plana se pierde */
    var d = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    return function (el, v) {
      if (d && d.set) d.set.call(el, v); else el.value = v;
      el.dispatchEvent(new Event('input', { bubbles: true }));
    };
  })();

  function prepararTeclado(campo) {
    /* el campo esta configurado como 5 digitos numericos, pero el <input> sale
       sin inputmode ni maxlength: en el celular abre teclado de letras */
    if (campo.getAttribute('inputmode') !== 'numeric') campo.setAttribute('inputmode', 'numeric');
    if (!campo.getAttribute('maxlength')) campo.setAttribute('maxlength', '5');
    if (!campo.getAttribute('autocomplete')) campo.setAttribute('autocomplete', 'postal-code');
    campo.setAttribute('pattern', '[0-9]*');
  }

  /* Solo digitos: inputmode es una PISTA para el teclado del movil, no impide
     escribir letras en el computador ni pegarlas desde el portapapeles. */
  function soloNumeros(campo) {
    var limpio = (campo.value || '').replace(/[^0-9]/g, '').slice(0, 5);
    if (limpio !== campo.value) {
      var pos = campo.selectionStart;
      ponerValorInput(campo, limpio);
      try { campo.setSelectionRange(Math.min(pos, limpio.length), Math.min(pos, limpio.length)); } catch (e) { }
      return true;   /* hubo que corregir: el evento de este cambio ya viene solo */
    }
    return false;
  }

  var ultimoCP = null;
  /* Si rellenamos nosotros, somos responsables de limpiar cuando el codigo deja
     de ser valido. Si lo eligio la persona a mano, NO se le toca: puede vivir en
     un municipio cubierto cuyo CP concreto no este en la lista. */
  var loRellenamosNosotros = false;
  var objetivo = null;            /* {estado, municipio} que deberia estar puesto */

  function limpiarSiEsNuestro() {
    if (!loRellenamosNosotros) return false;
    objetivo = null;
    var prov = document.querySelector(SEL_ESTADO);
    if (prov) ponerSelect(prov, '');   /* al vaciar el estado, Releasit limpia el municipio */
    loRellenamosNosotros = false;
    return true;
  }

  async function resolver(campo) {
    var cp = (campo.value || '').replace(/\D/g, '').slice(0, 5);

    if (cp.length !== 5) {
      /* Al borrar el codigo, lo que habiamos rellenado deja de tener respaldo:
         se limpia para que no quede un estado y un municipio sin codigo. */
      aviso(campo, '');
      ultimoCP = null;
      limpiarSiEsNuestro();
      return;
    }
    if (cp === ultimoCP) return;
    ultimoCP = cp;

    var r = buscar(cp);
    if (!r) return;                                  /* sin catalogo: no hacemos nada */

    if (!r.encontrado) {
      /* CLAVE: no dejar el estado y el municipio del codigo ANTERIOR pegados a
         un codigo nuevo que no les corresponde. Eso mandaria a Dropi una
         direccion contradictoria sin que nadie se entere. */
      var limpiado = limpiarSiEsNuestro();
      aviso(campo, limpiado
        ? 'Ese código postal no aparece en nuestra cobertura. Revísalo, o elige tu estado y municipio abajo.'
        : 'Ese código postal no aparece en nuestra cobertura. Revísalo antes de continuar.');
      return;
    }
    aviso(campo, '');

    var prov = document.querySelector(SEL_ESTADO);
    if (!prov) return;
    if (!r.estadoUnico) return;                      /* rarisimo: mismo CP en dos estados */
    if (!ponerSelect(prov, r.estado)) return;
    loRellenamosNosotros = true;
    objetivo = { estado: r.estado, municipio: null };

    if (r.ambiguo || !r.municipio) return;           /* el estado ya esta; el municipio lo elige la persona */

    await new Promise(function (res) { setTimeout(res, ESPERA_RENDER_MS); });
    var ciudad = await esperarSelect('city', TOPE_ESPERA_MS);
    if (ciudad && ponerSelect(ciudad, r.municipio)) objetivo.municipio = r.municipio;
  }

  /* --- 4bis. El eco del telefono ------------------------------------------
     Muestra debajo del campo el numero tal como quedo, ya formateado, para que
     la persona vea su propio telefono y note el dedazo ANTES de enviar. NO
     comprueba que el numero tenga WhatsApp: eso no se puede desde la pagina,
     porque la API oficial de Meta no tiene ningun endpoint para consultarlo y
     en Mexico ni siquiera se distingue un celular de un fijo (la numeracion se
     unifico en 2019). Esto es cero red, cero costo y no bloquea nada. */

  var MARCA_TEL = 'vd-tel-eco';

  function prefijoPais(campo) {
    /* el prefijo vive en un <span> hermano dentro de la misma fila; se lee de
       ahi en vez de escribir "+52" a mano, por si se cambia el pais */
    var fila = campo.parentElement;
    if (fila) {
      var sp = fila.querySelector('span');
      var t = sp && (sp.textContent || '').trim();
      if (t && /^\+\d{1,4}$/.test(t)) return t;
    }
    return '+52';
  }

  /* Agrupacion mexicana: 55/56/33/81 llevan lada de 2 digitos, el resto de 3 */
  function formatoMx(n) {
    var dos = ['55', '56', '33', '81'];
    if (dos.indexOf(n.slice(0, 2)) >= 0) return n.slice(0, 2) + ' ' + n.slice(2, 6) + ' ' + n.slice(6);
    return n.slice(0, 3) + ' ' + n.slice(3, 6) + ' ' + n.slice(6);
  }

  function ecoTelefono(campo) {
    var n = (campo.value || '').replace(/\D/g, '');
    if (n.length > 10 && n.slice(0, 2) === '52') n = n.slice(-10);   /* pegaron el codigo de pais */
    if (n.length !== 10) { quitarNota(campo, MARCA_TEL); return; }

    var pref = prefijoPais(campo);
    var bonito = pref + ' ' + (pref === '+52' ? formatoMx(n) : n);
    var caja = notaBajo(campo, MARCA_TEL, 'color:#c7c7c7');
    if (!caja) return;
    while (caja.firstChild) caja.removeChild(caja.firstChild);
    caja.appendChild(document.createTextNode('Te escribiremos por WhatsApp al '));
    var b = document.createElement('b');
    b.style.color = '#ffffff';
    b.textContent = bonito;
    caja.appendChild(b);
  }

  function engancharTelefono() {
    var campo = document.querySelector('input[name="phone"]');
    if (!campo || campo.dataset.vdTel === '1') return;
    campo.dataset.vdTel = '1';
    /* el <input> sale sin inputmode: en el celular conviene el teclado telefonico */
    if (!campo.getAttribute('inputmode')) campo.setAttribute('inputmode', 'tel');
    if (!campo.getAttribute('autocomplete')) campo.setAttribute('autocomplete', 'tel-national');
    var t = null;
    campo.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { try { ecoTelefono(campo); } catch (e) { } }, RETARDO_TECLEO_MS);
    });
    campo.addEventListener('blur', function () { try { ecoTelefono(campo); } catch (e) { } });

    /* Releasit solo acepta 10 digitos pelados: si se pega "+52 999 123 4567" o
       el numero con espacios, DEJA EL CAMPO VACIO y la persona puede no notarlo.
       Comprobado en vivo. Aqui se normaliza lo pegado antes de que llegue. */
    campo.addEventListener('paste', function (ev) {
      try {
        var texto = (ev.clipboardData || window.clipboardData).getData('text') || '';
        var d = texto.replace(/\D/g, '');
        if (d.length > 10 && d.slice(0, 2) === '52') d = d.slice(-10);
        if (d.length !== 10) return;                 /* no sabemos arreglarlo: que siga su curso */
        ev.preventDefault();
        ponerValorInput(campo, d);
        setTimeout(function () { try { ecoTelefono(campo); } catch (e) { } }, 0);
      } catch (e) { /* si falla, el pegado normal sigue funcionando */ }
    });

    ecoTelefono(campo);   /* por si ya venia relleno */
  }

  /* --- 5. El reconciliador -------------------------------------------------
     El <select> de Estado de Releasit lleva onBlur ademas de onChange, asi que
     con solo tocarlo y salir vuelve a correr la cascada y VACIA el municipio,
     aunque no se haya cambiado nada. Esto lo devuelve a su sitio. Solo actua
     sobre lo que pusimos nosotros y solo mientras la persona no lo haya tocado
     con su propia mano. */
  function reconciliar() {
    if (!objetivo || !loRellenamosNosotros) return;
    var prov = document.querySelector(SEL_ESTADO);
    if (!prov || prov.value !== objetivo.estado) return;
    if (!objetivo.municipio) return;
    var ciudad = document.querySelector('select[name="city"]');
    if (!ciudad || ciudad.value === objetivo.municipio) return;
    if (ciudad.value !== '') return;          /* si tiene OTRO valor, lo puso la persona */
    ponerSelect(ciudad, objetivo.municipio);
  }

  /* Si la persona toca el Estado o el Municipio con su propia mano, deja de ser
     "nuestro" y no se lo borramos ni se lo reponemos nunca mas. */
  function vigilarManoAjena() {
    document.addEventListener('change', function (ev) {
      if (escribiendoNosotros) return;
      var n = ev.target && ev.target.name;
      if (n !== 'province_country_field' && n !== 'city') return;
      /* Ojo: el vaciado que provoca el propio onBlur de Releasit tambien llega
         aqui. Se distingue porque deja el municipio en blanco sin que el estado
         haya cambiado; en ese caso NO se cede el control, lo repone el
         reconciliador. */
      if (n === 'city' && ev.target.value === '' && objetivo && objetivo.municipio) return;
      loRellenamosNosotros = false;
      objetivo = null;
    }, true);
  }

  function enganchar() {
    var campo = campoCP();
    if (!campo || campo.dataset.vdCp === '1') return;
    campo.dataset.vdCp = '1';
    prepararTeclado(campo);
    /* Armar el indice cuesta ~60 ms. Se hace AHORA, en cuanto aparece el
       formulario y con el navegador libre, para que no coincida con el tecleo
       del codigo postal y le congele el dedo a la persona. */
    calentarIndice();
    var t = null;
    campo.addEventListener('input', function () {
      if (soloNumeros(campo)) return;    /* la correccion dispara otro 'input' */
      clearTimeout(t);
      t = setTimeout(function () { resolver(campo).catch(function () { }); }, RETARDO_TECLEO_MS);
    });
    campo.addEventListener('blur', function () { resolver(campo).catch(function () { }); });
    campo.addEventListener('paste', function () { setTimeout(function () { soloNumeros(campo); }, 0); });
  }

  function arrancar() {
    try {
      vigilarManoAjena();
      enganchar();
      engancharTelefono();
      setInterval(function () { try { reconciliar(); } catch (e) { } }, VIGILANCIA_MS);
      var obs = new MutationObserver(function () {
        try { enganchar(); } catch (e) { }
        try { engancharTelefono(); } catch (e) { }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) { /* si esto falla, el formulario queda exactamente como hoy */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  /* expuesto solo para poder probarlo desde la consola sin tocar el formulario */
  window.__vdCP = {
    buscar: buscar,
    reindexar: function () { indice = construirIndice(); return indice; },
    listo: function () { return indice !== null && indice !== false; },
    estado: function () { return { objetivo: objetivo, nuestro: loRellenamosNosotros, ultimoCP: ultimoCP }; }
  };
})();
